import { Box, Stack } from "@mui/material";
import _ from "lodash";

import { enumService } from "@/common/services/enum";
import { GeneralCurrencyDto, SubscriptionPlanPriceDto } from "@/core/api/generated/v1";

import InlineApiEnumValue from "../../Enum/InlineApiEnumValue";
import FieldValue from "../../Form/Display/FieldValue";
import GeneralPriceSummaryDisplay from "../../PriceSummary/GeneralPriceSummaryDisplay";
import GeneralPriceDisplay from "../General/GeneralPrice/GeneralPriceDisplay";

interface Props {
  currency: Nil<GeneralCurrencyDto>;
  basePrice: Nil<SubscriptionPlanPriceDto>;
  price: Nil<SubscriptionPlanPriceDto>;
}

export default function SubscriptionPlanPriceDisplay({ currency, basePrice, price }: Props) {
  if (!basePrice || !price) {
    return null;
  }

  return (
    <Stack
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(2, 1fr)`,
        gap: 4,
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: `repeat(1, 1fr)`,
          gap: 1,
          alignContent: "start",
          justifyContent: "start",
        }}
      >
        <FieldValue label='Type' direction='row'>
          {price.isBase ? "Base" : "Alternative"}
        </FieldValue>

        <FieldValue label='Billing period' direction='row' isEmpty={!price.period}>
          <InlineApiEnumValue type='BillingPeriod' value={price.period} />
        </FieldValue>

        <FieldValue
          label={`Price per ${
            basePrice?.period
              ? enumService.getEnumValueName("BillingPeriod", basePrice?.period)
              : "-"
          }`}
          direction='row'
          isEmpty={_.isNil(price.price)}
        >
          <GeneralPriceDisplay
            price={{
              price: price.price,
              currency: currency || undefined,
            }}
          />
        </FieldValue>
      </Box>

      <GeneralPriceSummaryDisplay
        summary={{
          currency: currency,
          subTotal: price.subTotal,
          total: price.total,
          discount: price.discount,
          tax: price.tax,
          insurance: price.insurance,
        }}
        displayProps={{
          insurance: true,
          calcExplanationPopover: true,
          calcExplanationModal: true,
        }}
        direction='column'
      />
    </Stack>
  );
}
